export default __webpack_public_path__ + "static/media/testimonial-2.c26ff49c.png";